import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatTableDataSource
} from '@angular/material';
import { TranslateService } from '@ngx-translate/core';
import * as XLSX from 'xlsx';
import uuidv4 from 'uuid/v4';
type AOA = any[][];

@Component({
  selector: 'sc-noa-validation',
  templateUrl: './popupNoaError.component.html',
  styleUrls: ['./popupNoaError.component.css']
})
export class NoaErrorPopUpComponent implements OnInit {
  public dataSource: any;
  public displayedColumns: string[] = ['poNumber', 'status', 'detail'];
  public showTable = false;
  public module: string;

  constructor(
    public dialogRef: MatDialogRef<NoaErrorPopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translateService: TranslateService
  ) {}

  public ngOnInit() {
    this.module = this.data.module.toUpperCase();
    this.dataSource = new MatTableDataSource(this.data.result);
  }

  public export(): void {
    const header = [
      this.translateService.instant(
        this.module + '.PURCHASE_ORDER.POPUP.PO_NUMBER'
      ),
      this.translateService.instant(
        this.module + '.PURCHASE_ORDER.POPUP.STATUS'
      ),
      this.translateService.instant(
        this.module + '.PURCHASE_ORDER.POPUP.DETAIL'
      )
    ];

    const data: AOA = this.dataSource.data.reduce((table, item) => {
      if (item.successful) {
        table.push([
          item.poNumber,
          this.translateService.instant(
            this.module + '.PURCHASE_ORDER.POPUP.SUCCESS'
          )
        ]);
      } else {
        let detail = '';
        if (item.codes && item.codes.length) {
          detail = item.codes.reduce(
            (res, code) =>
              res +
              this.translateService.instant(
                this.module + '.PURCHASE_ORDER.POPUP.ERROR_CODE.' + code
              ) +
              ' \n',
            ''
          );
        } else {
          detail = this.translateService.instant(
            this.module + '.PURCHASE_ORDER.POPUP.ERROR_CODE.UNKNOWN'
          );
        }
        table.push([
          item.poNumber,
          this.translateService.instant(
            this.module + '.PURCHASE_ORDER.POPUP.ERROR'
          ),
          detail
        ]);
      }
      return table;
    }, []);

    data.unshift(header);

    /* generate worksheet */
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, uuidv4() + '.xlsx');
  }

  public close(): void {
    this.dialogRef.close();
  }
}
